package com.appsyde.shared.modules.account.data.source

import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.parameter
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType
import kotlinx.serialization.Serializable

@Serializable
private data class GetStatusResponse(val status: String, val accountPrimaryEmail: String? = null, val message: String? = null)

@Serializable
private data class PostConfirmRequest(val token: String)

@Serializable
private data class PostConfirmResponse(val status: String, val message: String? = null)

class ConfirmDeletionDataSourceImpl(
    private val http: io.ktor.client.HttpClient,
    private val baseUrl: String
) : ConfirmDeletionDataSource {

    private fun confirmUrl() = baseUrl.trimEnd('/') + "/confirm-account-deletion"

    override suspend fun getStatus(token: String): ConfirmDeletionStatusDto {
        return try {
            val response = http.get(confirmUrl()) {
                parameter("token", token)
            }
            val body = response.body<GetStatusResponse>()
            when (body.status) {
                "valid" -> ConfirmDeletionStatusDto.Valid(body.accountPrimaryEmail ?: "")
                "expired" -> ConfirmDeletionStatusDto.Expired
                "already_used" -> ConfirmDeletionStatusDto.AlreadyUsed
                else -> ConfirmDeletionStatusDto.Invalid
            }
        } catch (_: Exception) {
            ConfirmDeletionStatusDto.Invalid
        }
    }

    override suspend fun executeDeletion(token: String): ConfirmDeletionResultDto {
        return try {
            val response = http.post(confirmUrl()) {
                contentType(ContentType.Application.Json)
                setBody(PostConfirmRequest(token = token))
            }
            val body = response.body<PostConfirmResponse>()
            when (body.status) {
                "deleted" -> ConfirmDeletionResultDto.Deleted
                "already_used" -> ConfirmDeletionResultDto.AlreadyUsed
                else -> ConfirmDeletionResultDto.InvalidOrExpired
            }
        } catch (_: Exception) {
            ConfirmDeletionResultDto.InvalidOrExpired
        }
    }
}
